<div class="ft-modal-view ready-to-share">
    <h1 class="modal-heading ft-text-plus-3">
        Your broadcast is ready for {{ network()?.name | capitalize }}.
    </h1>
    <div class="modal-summary">
        @if (!isInstagram() && shareType() == 1) {
            <p>
                Your post will link to
                @if (!!shareUrl() && !!first()) {
                    <a target="_blank" [href]="shareUrl()">
                        {{ first() }}'s page
                    </a>
                }
                on Story Explorer.
            </p>
        }
        @if (!isInstagram() && shareType() == 2) {
            <p>
                Your post will link to your
                @if (!!shareUrl()) {
                    <a target="_blank" [href]="shareUrl()">
                        Storytellers Invitation Page
                    </a>
                }.
            </p>
        }
        @if (!isInstagram() && shareType() == 3) {
            <p>
                Your post will link to
                @if (!!shareUrl()) {
                    <a target="_blank" [href]="shareUrl()">
                        your website
                    </a>
                }.
            </p>
        }
        @if (isInstagram()) {
            <p>
                {{ 'flipto.account.DownloadImageInstagramInstructions' | translate }}
            </p>
        }
    </div>

    <form #shareImageReadyForm="ngForm" novalidate (ngSubmit)="submitShare(shareImageReadyForm)">
        <div class="ft-broadcast-editor">
            @if (!isRecommendationSetup()) {
                <div [class]="{'ft-field-error': shareImageReadyForm.controls['message']?.invalid && shareImageReadyForm.submitted, 'field-error': shareImageReadyForm.controls['message']?.invalid && shareImageReadyForm.submitted}">
                    @if (isTwitter() || isLinkedIn()) {
                        <textarea class="form-control ft-share-message" placeholder="{{ 'flipto.account.AddYourMessage' | translate }}"
                                  maxlength="116" name="message" [(ngModel)]="message" required></textarea>
                    }
                </div>
            }
            <div class="ft-preview-container image">
                <img class="ft-preview" [src]="shareImageUrl()" />
            </div>
            <p class="modal-fineprint ft-text-minus-1">
                @if (!isInstagram()) {
                    <a (click)="onDownloadShareImage()">Download this image.</a>
                } If the image hasn't rendered properly, <a (click)="onReprocessImage()">reprocess</a> it.
            </p>
        </div>
        @if (!isInstagram() && !isRecommendationSetup()) {
            <button type="submit" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm">
                <span class="ft-btn-label">Looks good!</span>
                <span class="ft-btn-subline">Share to {{ network()?.name | capitalize }} <i class="ft-icn-arrow-right"></i></span>
            </button>
        }
        @if (isInstagram() && !isRecommendationSetup()) {
            <button type="button" class="ft-btn ft-btn-plus-1 ft-btn-default ft-btn-confirm"
                    (click)="onDownloadShareImage()">
                {{ 'flipto.account.Download' | translate }}
            </button>
        }
    </form>
</div>
